const en = {
  contactSupport: {
    title: "Contact Support",
    content: [
      "Do you have a question to ask?",
      "You can contact us at this email address for assistance.",
    ],
    button: "Got it",
    download_tips: "This App is not yet online, please wait patiently",
  },
  selectLanguage: {
    title: "LANGUAGE & CURRENCY",
    titleLanguage: "Language*",
    titleCurrency: "currency*",
    headerTitle: "LANGUAGE & CURRENCY",
    hint: "You can set the language according to your preferences, which will make it easier for you to get to know us.",
    button: "Save Preferences",
    language: "YOUR LANGUAGE",
    currency: "YOUR CURRENCY",
  },
  meau: ["File Access", "Product File"],
  banner: {
    list: [
      {
        title1: "Loot Bar: ",
        title2: "Tyria Epic gold selling mall!",
        essay:
          "Loot Bar is the world's most popular game props trading mall, in Loot Bar products, you can quickly buy your favorite props, we provide you with a great experience, use it now!",
        btn: "Download this App！",
      },
    ],
    button: "CONTACT US NOW",
  },

  introduce: {
    title: "What We Offer",
    essay:
      "We've established a comprehensive game trading market and trading system to provide a good asset environment for your game, increase its number of active players, and help your game keep growing.",
  },
  partner: {
    title: "Integrated Games",
  },
  contact: {
    title: "Let's Give Your Game a Boost!",
    essay:
      "We'll work to help you create a good marketplace for your game to support its continuous growth.",
    hint: "Stay with us,your game will continue to improve.",
    input: [
      {
        placeholder: "email",
        error: "Please enter your email",
      },
      {
        placeholder: "company",
        error: "Please enter your company name",
      },
    ],
    form: {
      title: "CONTACT AN EXPERT",
      hint: "We look forward to learning about your needs!",
      button: "CREATE REQUEST",
    },
  },
  contactForm: {
    title: "How we can help?",
    hint: "Please select at least one option",
    inputList: {
      list: [
        { placeholder: "Enter first name *", error: "Please enter your first name." },
        { placeholder: "Enter last name *", error: "Please enter your last name." },
        { placeholder: "What best describes your role？*", error: "Please select your role." },
      ],

      selectList: [
        { name: "CEO/Executive/Founder", translate: "首席执行官/执行总裁/创始人" },
        { name: "Game Developer/Programmer", translate: "游戏开发者/程序员" },
        { name: "Marketer", translate: "营销人员" },
        { name: "Business Developer", translate: "业务开发员" },
        { name: "Product Manager", translate: "产品经理" },
        { name: "Finance & Payments", translate: "金融与支付" },
        { name: "Operations/Monetization", translate: "运营/货币化" },
        { name: "Finance & Payments", translate: "金融与支付" },
        { name: "Operation/Monetization", translate: "运营/货币化" },
        { name: "Producer", translate: "生产者" },
        { name: "Other", translate: "其他" },
      ],
    },
    checkList: {
      list: [
        "I am looking forward to a new growth path for my products",
        "I look forward to working with the trading platform",
        "Not sure",
      ],
      error: "Please choose one or more options",
    },
    lastForm: {
      list: [
        { placeholder: "Enter  company website *", error: "Please enter your company website." },
        {
          placeholder: "Indicate number of employees *",
          error: "Please enter number of employees.",
        },
        { placeholder: "Enter name of your game *", error: "Please enter your name of your game." },
        { placeholder: "How did you hear about us？*", error: "Please choose one option." },
      ],

      selectList: [
        { name: "Online Ad", translate: "在线广告" },
        { name: "Print Ad", translate: "印刷广告" },
        { name: "Referral", translate: "推荐人" },
        { name: "Search", translate: "搜索" },
        { name: "Press/News", translate: "媒体/新闻" },
        { name: "Social Media", translate: "社会媒体" },
        { name: "Other", translate: "其他" },
      ],
    },
    button: {
      back: "Back",
      submit: "Next",
    },
  },
  modalSuccess: {
    title: "ok",
    essay: "Your request has been successfully sent. We will contact you shortly.",
    button: "Continue",
  },
};

export default en;
